'use es6';

import { connect } from 'react-redux';
import FormFieldInputLabel from 'FormsUI/components/editor/form/formFields/FormFieldInputLabel';
import { getObjectById } from 'FormsUI/selectors/customObjects';
const mapStateToProps = (state, props) => ({
  objectType: getObjectById(state, props.objectTypeId)
});
const actionsToBind = {};
export default connect(mapStateToProps, actionsToBind)(FormFieldInputLabel);